export const userMessagePreviewTemplateIds = ['feedbackRequest', 'contactRequest'] as const

export type UserMessagePreviewTemplateId = (typeof userMessagePreviewTemplateIds)[number]

export const userMessagePreviewChannels = ['email', 'sms'] as const

export type UserMessagePreviewChannel = (typeof userMessagePreviewChannels)[number]

export const userMessagePreviewVariants = ['default', 'active', 'preliminary'] as const

export type UserMessagePreviewVariant = (typeof userMessagePreviewVariants)[number]

export const userMessagePreviewShortenedFields = [
  'realtorName',
  'recipientName',
  'companyName',
  'areaName',
] as const

export type UserMessagePreviewShortenedField = (typeof userMessagePreviewShortenedFields)[number]

export type UserMessagePreviewDescriptor = {
  templateId: UserMessagePreviewTemplateId
  channel: UserMessagePreviewChannel
  variant: UserMessagePreviewVariant
}

export const userMessagePreviewDefinitions = [
  {
    templateId: 'feedbackRequest',
    channel: 'email',
    variant: 'default',
  },
  {
    templateId: 'feedbackRequest',
    channel: 'sms',
    variant: 'default',
  },
  {
    templateId: 'contactRequest',
    channel: 'sms',
    variant: 'active',
  },
  {
    templateId: 'contactRequest',
    channel: 'sms',
    variant: 'preliminary',
  },
] as const satisfies readonly UserMessagePreviewDescriptor[]

export type UserMessagePreview = UserMessagePreviewDescriptor & {
  fromLabel: string | null
  replyTo: string | null
  senderId: string | null
  recipientName: string
  subject: string | null
  html: string | null
  text: string
  shortenedFields: UserMessagePreviewShortenedField[]
}
